/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone, PhoneIncoming, PhoneOff } from "lucide-react";
import { walletApi, gbp, fmtDate } from "@/lib/wallet";
import SEO from "@/components/site/SEO";
import CustomerBottomNav from "@/components/customer/CustomerBottomNav";

export default function CustomerCallHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await walletApi.get("/customer/calls/history?limit=100");
        setItems(data.items || []);
      } catch (err) { console.error("Could not load call history", err); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-brand-bgSoft text-brand-ink pb-24 md:pb-0" data-testid="customer-call-history">
      <SEO title="Call history" path="/app/calls" />
      <header className="bg-white border-b border-brand-line">
        <div className="container-page flex items-center justify-between h-16">
          <Link to="/app" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-ink/80 hover:text-brand-ink">
            <ArrowLeft className="h-4 w-4" /> Dashboard
          </Link>
          <Link to="/app/dial" className="text-xs font-semibold text-brand-greenDark">New call →</Link>
        </div>
      </header>

      <div className="container-page py-10 max-w-3xl">
        <h1 className="font-display font-black text-2xl mb-6">Call history</h1>
        {loading ? (
          <div className="text-sm text-brand-muted">Loading…</div>
        ) : items.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-brand-line bg-white p-10 text-center">
            <Phone className="h-8 w-8 text-brand-muted mx-auto" />
            <p className="mt-3 font-semibold">No calls yet</p>
            <Link to="/app/dial" className="mt-3 inline-block text-sm font-semibold text-brand-greenDark">Make your first call →</Link>
          </div>
        ) : (
          <ul className="divide-y divide-brand-line rounded-2xl border border-brand-line bg-white" data-testid="call-history-list">
            {items.map((c) => (
              <li key={c.id} className="p-4 flex items-center gap-3" data-testid={`call-${c.id}`}>
                <div className={`h-9 w-9 rounded-full flex items-center justify-center ${c.status === "completed" ? "bg-emerald-50 text-emerald-600" : c.status === "failed" ? "bg-rose-50 text-rose-600" : "bg-amber-50 text-amber-600"}`}>
                  {c.status === "completed" ? <PhoneIncoming className="h-4 w-4" /> :
                   c.status === "failed" ? <PhoneOff className="h-4 w-4" /> :
                   <Phone className="h-4 w-4" />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold truncate">{c.to_e164}</p>
                  <p className="text-xs text-brand-muted">{c.destination?.country_name || "—"} · {fmtDate(c.created_at)}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-bold">{c.duration_seconds || 0}s</p>
                  <p className="text-xs text-brand-muted">{gbp(c.cost ?? (c.cost_minor || 0) / 100)}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <CustomerBottomNav />
    </div>
  );
}
